/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-22 16:15:22
 */
export default {
  path: '/',
  name: 'taskManage',
  hidden: false,
  meta: {
    title: '任务管理',
    level: 1,
    nav: 'task',
    icon: 'fa fa-tasks iconTitle',
    role: ['admin', 'topunion', 'levelunion']
  },
  component: () => import('@/views/Application.vue'),
  children: [
    {
      path: '/selfTask',
      name: 'selfTask',
      hidden: false,
      meta: {
        title: '我下达的任务',
        level: 2,
        nav: 'selfTask',
        iconClass: 'icon-task',
        icon: 'fa fa-tasks iconTitle',
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/self-task')
    },
    {
      path: '/superiorTask',
      name: 'superiorTask',
      level: 2,
      hidden: false,
      meta: {
        title: '我接收的任务',
        nav: 'superiorTask',
        iconClass: 'icon-supertask',
        icon: 'fa fa-tasks iconTitle',
        role: ['levelunion']
      },
      component: () => import('@/views/task-manage/superior-task')
    },
    {
      path: '/selfTaskDetail/:type/:id',
      name: 'taskInfo',
      hidden: true,
      meta: {
        title: '任务详情',
        nav: 'selfTask',
        level: 3,
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/task-detail')
    },
    {
      path: '/selfTaskDetail/submitInfo',
      name: 'taskInfo',
      hidden: true,
      meta: {
        title: '相关材料提交设置',
        nav: 'submitInfo',
        level: 3,
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/submit-info')
    },
    {
      path: '/superiorTaskDetail/:type/:id',
      name: 'taskInfo',
      hidden: true,
      meta: {
        title: '任务详情',
        nav: 'superiorTask',
        level: 3,
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/task-detail')
    },
    {
      path: '/showPlayerStatus/:activityId',
      name: 'playerStatus',
      hidden: true,
      meta: {
        title: '选手状态',
        nav: 'task',
        level: 3,
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/player-contest-status')
    },
    {
      path: '/showResult',
      name: 'showResult',
      hidden: true,
      meta: {
        title: '查看结果',
        nav: 'task',
        level: 3,
        role: ['admin', 'topunion', 'levelunion']
      },
      component: () => import('@/views/task-manage/show-result/index2.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/taskManage.js